import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Send } from "@mui/icons-material";
import { useEjes } from "../hooks/useEjes"
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { CardUI } from "../components/commons/CardUI.jsx";
import Container from "@mui/material/Container";
import { ListaNoticias } from "../components/ListaNoticias.jsx";
import { useNoticia } from "../hooks/useNoticia";
import Parser from "html-react-parser";
import Link from "@mui/material/Link";
import InfoIcon from "@mui/icons-material/Info";
import logoImage from "../images/logoMadurezDigital.png";

import "../styles/Home.css";
import "../App.css";
import ModalConfirmar from "../components/commons/ModalConfirmar";
import colors from "../theme/colors";

export function Home() {
  const { ejes } = useEjes()
  const { t } = useTranslation()
  const navigate = useNavigate()

  function Comenzar() {
    navigate("/Identificarse");
  }

  return (
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        <Stack
          direction={{ xs: "column", sm: "column", md: "row" }}
          alignItems="center"
          spacing = {{ xs: 2, sm: 2, md: 12 }}
          marginTop={3}
        >
          <Box
            component="img"
            src={logoImage}
            alt="Autodiagnóstico Madurez Digital Logo"
            sx={{
              width: {xs: "350px", md: "350px" },
              height: 'auto',
            }}
          />
          <Stack direction="column" alignItems="flex-start" spacing={2}>
            <Typography
              variant="h1"
              margin={0}
            >
              {t("home.titulo")}
            </Typography>
            <Box marginBottom={2}>
              <Typography variant="parrafo" textAlign={"justify"}>
                {Parser(t("home.infoText1"))}
              </Typography>
            </Box>
            <ModalConfirmar
              title={t("home.infoEconomiaCircular")}
              text={
                t("home.infoText2")
              }
              cancelText={t("general.cerrar")}
            >
              <Link
                underline="hover"
                variant="link"
              >
                <Stack
                  direction={"row"}
                  gap={1}
                  alignItems={"center"}
                  fontWeight={"bold"}
                >
                  <InfoIcon />
                    {t("home.infoEconomiaCircular")}
                </Stack>
              </Link>
            </ModalConfirmar>
          </Stack>
        </Stack>
        <Grid item className="textCard" >
          <Stack padding={"1em"}>
            <Box textAlign={"center"}>
              <Typography variant="parrafo">
                {t("home.infoText5")}
              </Typography>
            </Box>
            <Box marginY={4}>
              <CardUI ejes={ejes} />
            </Box>

            <Box>
              <Button
                variant="contained"
                onClick={() => {
                  Comenzar();
                }}
                sx={{ marginTop: "10px", paddingY: "1.2em" }}
                endIcon={<Send sx={{ color: colors.textMain }} />}
                size="large"
              >
                {t("home.botonIniciar")}
              </Button>
            </Box>
          </Stack>
        </Grid>
      </Grid>
  );
}
